import footerController from './footer.controller.js';

function pageFooter() {
  return {
    template: require('./umb.pageFooter.html'),
    controller: footerController
  };
};
export default pageFooter;


// WEBPACK FOOTER //
// ./src/login/footer/umb.pageFooter.js